import { useMemo } from "react";
import { useConnectors } from "wagmi";
import { EvmWallet } from "../../core/types/wallet";
import {
  filterWagmiConnector,
  formatEvmWallet,
} from "../../services/internal/evmService";

export function useEvmWallets(): {
  wallets: EvmWallet[];
} {
  const connectors = useConnectors();

  const wallets = useMemo(() => {
    return connectors.filter(filterWagmiConnector).map(formatEvmWallet);
  }, [connectors]);

  return {
    wallets,
  };
}
